import React from 'react';
import {SecondaryCollapsibleSection} from "../../../../../../../elements/collapsableSection/secondary/SecondaryCollapsibleSection";
import {ValidationResult} from "../../../../../../../elements/validator/component/ValidationComponent";
import {CustomSmallInputField} from "../../../../../../../elements/customSmallInputField/CustomSmallInputField";
import {ErrorState, SubtractionRule} from "../SubtractionRule/SubtractionRule";
import {useAppSelector} from "../../../../../../../../app/hooks";
import {selectRetailPriceRules, UpdateRetailPriceRuleRequestPartial} from "../../../toolSettingsSlice";
import {VehiclePriceDiscountRulesValidator} from "../../../../../../../elements/validator/Validator";
import {DependantValidationComponent} from "../../../../../../../elements/validator/dependant/DependantValidationComponent";
import {UpdateBotToolSettingsRequest, UpdateRetailPriceRuleRequest} from "../../../../../../../../api/generated";
import styles from "./VehiclePriceDiscount.module.css";

interface Props {
    getMessage: (f: string) => string;
    updateValidationStatus: (status: ValidationResult<UpdateBotToolSettingsRequest>) => void;
    addNewRetailPriceRule: (previousRuleIndex: number) => void;
    updateRetailPriceRule: (index: number, rule: UpdateRetailPriceRuleRequest) => void;
    deleteRetailPriceRule: (ruleIndex: number) => void;
    disabled?: boolean;
}

export const VehiclePriceDiscount: React.FC<Props> = ({
    getMessage,
    updateValidationStatus,
    addNewRetailPriceRule,
    updateRetailPriceRule,
    deleteRetailPriceRule,
    disabled
}) => {
    const retailPriceRules = useAppSelector(selectRetailPriceRules) as UpdateRetailPriceRuleRequest[];

    const getErrorStateForRule = (index: number): ErrorState | undefined => {
        const rawError = getMessage('retailPriceRules');
        if (rawError) {
            try {
                const errorObject = JSON.parse(rawError);
                const ruleError = errorObject[index];
                if (ruleError) {
                    return {
                        maxValueErrorMessage: ruleError.maxValueErrorMessage,
                        subtractionErrorMessage: ruleError.subtractionErrorMessage
                    };
                }
            } catch (e) {
                // Ignore JSON parse errors
            }
        }
        return undefined;
    };

    return (
        <DependantValidationComponent<UpdateRetailPriceRuleRequestPartial[], UpdateBotToolSettingsRequest>
            onChange={v => v}
            updateValidationStatus={updateValidationStatus}
            fieldName={'retailPriceRules'}
            required={false}
            selector={selectRetailPriceRules}
            validator={VehiclePriceDiscountRulesValidator}
            label={"retailPriceRules"}
            anchorValueSelector={(state) => state.toolSettings.updateRequest.botPublicId}
            child={() =>
                <SecondaryCollapsibleSection disabled={disabled} title={"Vehicle Price Discount"}>
                    <div className={styles.minWrapper}>
                        <CustomSmallInputField
                            readOnly={true}
                            placeholder={"min value"}
                            setValue={() => {}}
                        />
                    </div>
                    {retailPriceRules?.map((rule, index) => (
                        <SubtractionRule
                            key={index}
                            rule={rule}
                            index={index}
                            isLastItem={index === (retailPriceRules?.length - 1)}
                            canBeDeleted={retailPriceRules.length !== 1}
                            errorState={getErrorStateForRule(index)}
                            addNewRetailPriceRule={addNewRetailPriceRule}
                            updateRetailPriceRule={updateRetailPriceRule}
                            deleteRetailPriceRule={deleteRetailPriceRule}
                            disabled={disabled}
                        />
                    ))}
                </SecondaryCollapsibleSection>
            }
        />
    );
};

